import { combineReducers } from '@reduxjs/toolkit';
import basicInfoReducer from './basicInfo';
import householdReducer from './household';
import assetsReducer from './assets';
import billsReducer from './bills';
import completeReducer from './complete';
import submitFAReducer from './submitFAForm';
import updateFAProfileReducer from './updateFAProfile';

import {
  BasicInfoForm,
  HouseholdForm,
  AssetsForm,
  BillsForm,
  CompleteForm,
  SubmitFAFormState,
  UpdateFAProfileFormState
} from '../types';

export interface FinancialAssistanceState {
  basicInfo: BasicInfoForm;
  household: HouseholdForm;
  assets: AssetsForm;
  bills: BillsForm;
  complete: CompleteForm;
  submitFAForm: SubmitFAFormState;
  updateFAProfile: UpdateFAProfileFormState;
}

export default combineReducers({
  basicInfo: basicInfoReducer,
  household: householdReducer,
  assets: assetsReducer,
  bills: billsReducer,
  complete: completeReducer,
  submitFAForm: submitFAReducer,
  updateFAProfile: updateFAProfileReducer
});
